export default __webpack_public_path__ + "static/itreview-banner-sp-4ea80d846ad2b3d8621106a5a705ab3f.png";